<template>
  <form action="">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">How does it work?</p>
      </header>
      <section class="modal-card-body">
        <p>Cloudprinter 'Quick order' simplifies a process of order submissions.
          <br>Fulfill your orders and save time.</p>

        <br>

        <b>1. Product setup</b>
        <ul>
          <li>- Select the product type -> category: Textbook BW( Black & White), Flyer etc.</li>
          <li>- Second, select product options such as the main paper, cover paper & finishing, page count.</li>
          <li>- Third, enter the preferred quantity.</li>
          <li>- Choose between two storage options: provide us with the link to your print material or upload the file.</li>
        </ul>

        <br>

        <b>2. Shipping address</b>
        <p>Provide us with the shipping details. We require company name, first & last name, street name and number, ZIP code, city, country, email address and a phone number.</p>

        <br>

        <b>3. Shipping method</b>
        <p>Select a shipping option that is the most suitable for you.</p>

        <br>
        <b>4. Finish</b>
        <p>Click Finish to proceed to the Checkout. In this Checkout, you find a list of your orders.</p>

      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">Close</button>
      </footer>
    </div>
  </form>
</template>
<script>

export default {
  name: 'LearnMore'
}
</script>
